<template>
  <Tweet
    tweet_link="https://x.com/trondao/status/1886885632817160387"
    image_name="tron.png"
    name="TRON DAO"
    handle="@trondao"
    is_verified
    is_gold
  >
    #TRON welcomes its newest integration with <b>@bubblemaps</b>!
  </Tweet>
</template>

<script>
import Tweet from "@/components/atoms/Tweet.vue";

export default {
  components: {
    Tweet,
  },
};
</script>
